import { useEffect, useState } from "react";


export default function Mobikwik() {
    const [windowWidth, setWindowWidth] = useState(window.innerWidth);

    useEffect(() => {
        const handleResize = () => {
            setWindowWidth(window.innerWidth);
        };

        window.addEventListener("resize", handleResize);

        return () => {
            window.removeEventListener("resize", handleResize);
        };
    }, []);
    return (
        <section className="mt-4">
            <img
                src={windowWidth <= 768 ? "mobiApp.png" : "mobiWeb.png"}
                alt="banner"
                className={`w-full ${windowWidth <= 768 ? 'object-contain' : 'min-h-[320px] object-cover'} object-cover object-center`}

            />
        </section>
    );

}